import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {SystemNotificationModel} from '../models/system-notification.model';

@Injectable({
  providedIn: 'root'
})
export class SystemNotificationsService {
  systemNotificationsSubject = new Subject<SystemNotificationModel>();
}
